export type TreeNodeType = 'source' | 'contract' | 'table' | 'column';

export type TreeNode = {
  id: string;
  label: string;
  type: TreeNodeType;
  children?: TreeNode[];
  isExpanded?: boolean;
  isLoading?: boolean;
  metadata?: {
    contractId?: string;
    sourceType?: string;
    columnType?: string;
    tableName?: string;
  };
};

export type QueryResult = {
  columns: string[];
  rows: Record<string, unknown>[];
  executionTime?: number;
  error?: string;
};

export type ExplorerAgent = {
  name: string;
  displayName: string;
};

export const DEFAULT_AGENT: ExplorerAgent = {
  name: 'data-explorer-agent',
  displayName: 'Data Agent'
};

export type ExecutedQuery = {
  sql: string;
  timestamp: string;
  tool: string;
};

export type ColumnProfile = {
  columnName: string;
  distinctCount: number;
  nullCount: number;
  nullPercent: number;
  min?: number | string;
  max?: number | string;
  mean?: number;
  stddev?: number;
  topValues: { value: string; count: number }[];
  histogram?: { bucket: string; count: number }[];
};
